module.exports = __webpack_public_path__ + "src/assets/img/applogo.png";